export { IconVK } from './IconVk';
